import services from 'services';
import {map} from 'ramda';
import {describeThrow} from 'utils/errors';
import {reservationsQueryBase, reservationsInclude} from './constants';
import * as normalize from 'utils/normalize';
import msgs from 'dicts/messages';
import {mapResponseData} from 'utils/app';

let httpJson = null;
services.waitFor('api').then(x => (httpJson = x.httpJson));
let intl = null;
services.waitFor('intl').then(x => (intl = x));

export const getReservations = query =>
	httpJson('get', '/calendarResource', {
		...reservationsQueryBase,
		include: reservationsInclude,
		...query,
	})
		.catch(describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})))
		.then(mapResponseData(map(normalize.calendarResource)));
